// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\NewPortCall\AddPortCallRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AddVesselRequest, AddVesselRequestData, AddVesselRequestOptions } from 'data/models/AddVesselRequest';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { RecurringBatchRequest, RecurringBatchRequestData, RecurringBatchRequestOptions } from 'data/models/RecurringBatchRequest';

// AddPortCallRequestData is the class that AddPortCallRequest serializes to/from
export interface AddPortCallRequestData {
	
    AddVessel : AddVesselRequestData | null;
    BatchRequest : RecurringBatchRequestData | null;
    PortCall : PortCallData | null;
	
}

// AddPortCallRequestOptions is the class which may be passed to the AddPortCallRequest constructor to define optional initial data values
export interface AddPortCallRequestOptions {
	
    AddVessel? : AddVesselRequestOptions | null;
    BatchRequest? : RecurringBatchRequestOptions | null;
    PortCall? : PortCallOptions | null;
	
}

export class AddPortCallRequest {
	
    public AddVessel : DataSignal<AddVesselRequest | null>;
    public BatchRequest : DataSignal<RecurringBatchRequest | null>;
    public PortCall : DataSignal<PortCall | null>;
	

    constructor();
    constructor(data : AddPortCallRequestOptions);
    constructor(data: AddPortCallRequestOptions | null = null) {
	    
        this.AddVessel = S.value<AddVesselRequest | null>(null);
        this.BatchRequest = S.value<RecurringBatchRequest | null>(null);
        this.PortCall = S.value<PortCall | null>(null);
	    
    }

    static key(obj : AddPortCallRequest) {
        return ;
    }
    
    static dataKey(obj : AddPortCallRequestOptions) {
        return ;
    }

    static update(obj : AddPortCallRequest, data : AddPortCallRequestOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AddPortCallRequest.ts